import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-b1cc6fb0")
const _hoisted_1 = { class: "breadcrumb-settings" }
const _hoisted_2 = { class: "setting-item" }
const _hoisted_3 = { class: "setting-description" }
const _hoisted_4 = {
  key: 0,
  class: "setting-item"
}
const _hoisted_5 = { class: "setting-label" }
const _hoisted_6 = { class: "setting-description" }
const _hoisted_7 = {
  key: 1,
  class: "setting-item"
}
const _hoisted_8 = { class: "setting-label" }
const _hoisted_9 = { class: "breadcrumb-preview" }
const _hoisted_10 = { class: "modal-footer" }
_popScopeId()

import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: Boolean,
    default: false
  }
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props
const { t } = useI18n();
const store = useStore();




const isOpen = computed({
  get: () => props.modelValue,
  set: value => {
    if (!value) {
      emit("close");
    }
  }
});

const saving = ref(false);

// Local settings state
const localSettings = ref({
  enabled: true,
  maxItems: 5
});

// Load current settings when modal opens
watch(isOpen, newValue => {
  if (newValue) {
    loadCurrentSettings();
  }
});

const loadCurrentSettings = () => {
  const currentSettings = store.getters["userSettings/breadcrumbSettings"];
  localSettings.value = { ...currentSettings };
};

const saveSettings = async () => {
  if (saving.value) {
    return; // Prevent multiple simultaneous saves
  }

  saving.value = true;

  try {
    await store.dispatch(
      "userSettings/setBreadcrumbEnabled",
      localSettings.value.enabled
    );
    await store.dispatch(
      "userSettings/setBreadcrumbMaxItems",
      localSettings.value.maxItems
    );

    emit("close");
  } catch (error) {
    console.error("Failed to save breadcrumb settings:", error);
  } finally {
    saving.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_va_switch = _resolveComponent("va-switch")!
  const _component_va_slider = _resolveComponent("va-slider")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createBlock(_component_va_modal, {
    modelValue: _unref(isOpen),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isOpen) ? isOpen.value = $event : null)),
    title: _ctx.$t('breadcrumbSettings.title'),
    size: "small",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
    "hide-default-actions": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_va_button, {
          onClick: saveSettings,
          loading: saving.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("buttons.save")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_va_switch, {
            modelValue: localSettings.value.enabled,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (localSettings.value.enabled = $event)),
            label: _ctx.$t('breadcrumbSettings.enableBreadcrumb'),
            class: "setting-switch"
          }, null, 8, ["modelValue", "label"]),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("breadcrumbSettings.enableDescription")), 1)
        ]),
        (localSettings.value.enabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("breadcrumbSettings.maxItems")), 1),
              _createVNode(_component_va_slider, {
                modelValue: localSettings.value.maxItems,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (localSettings.value.maxItems = $event)),
                min: 2,
                max: 8,
                step: 1,
                label: localSettings.value.maxItems.toString(),
                class: "setting-slider"
              }, null, 8, ["modelValue", "label"]),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("breadcrumbSettings.maxItemsDescription")), 1)
            ]))
          : _createCommentVNode("", true),
        (localSettings.value.enabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("breadcrumbSettings.preview")), 1),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localSettings.value.maxItems, (index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["preview-item", {
              'preview-item--current': index === localSettings.value.maxItems
            }])
                  }, _toDisplayString(_ctx.$t("breadcrumbSettings.pageExample", { number: index })), 3))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})